import { CmsApiThreeStepCtaBlockData } from 'modules/cms/api/types/blocks/CmsApiThreeStepCtaBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsAmpThreeStepCtaBlock } from './CmsAmpThreeStepCtaBlock';
import { CmsThreeStepCtaBlock } from './CmsThreeStepCtaBlock';

export const CmsThreeStepCtaBlockMapping: CmsBlockMapping<CmsApiThreeStepCtaBlockData> =
  {
    invariant: [
      {
        prop: 'mainHeadline',
        msg: 'Main Heading required for Three Step Call-to-Action',
      },
    ],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsThreeStepCtaBlock,
    AmpComponent: CmsAmpThreeStepCtaBlock,
  };
